import { createContext, type ReactNode, useContext } from "react"
import { useAuth } from "./use-auth"

type SessionValue = ReturnType<typeof useAuth>

const SessionContext = createContext<SessionValue | null>(null)

/** Держит единственную сессию бэкофиса на всё приложение. */
export function SessionProvider({ children }: { children: ReactNode }) {
	const session = useAuth()
	return <SessionContext.Provider value={session}>{children}</SessionContext.Provider>
}

/** Текущая сессия: пользователь, состояние входа, `login` и `logout`. */
export function useSession(): SessionValue {
	const session = useContext(SessionContext)
	if (!session) throw new Error("useSession использован вне SessionProvider")
	return session
}
